import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndTestimonials } from './components/StatsAndTestimonials';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './utils/metaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-background text-gray-300 font-body selection:bg-gold selection:text-background" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsAndTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Modules data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <CostComparison data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
      <PurchaseToast data-id="element-10" />
    </div>;
}